import DropdownContent from './DropdownContent'

export default DropdownContent
